export const USER_HOME_KEY = 'qwealth_user_home_v2';
export const SELECTED_CONTACTS_KEY = 'SELECTED_CONTACTS_KEY';
export const MY_LIST_FILTER_KEY = 'MY_LIST_FILTER_V4';
